import { motion } from "framer-motion";
import XionLogo from "./XionLogo";

export default function Loader({ label = "INITIALIZING XION..." }) {
  return (
    <div className="min-h-[60vh] grid place-items-center bg-[#06060C]" data-testid="xion-loader">
      <div className="flex flex-col items-center gap-5">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "linear" }}
          className="drop-shadow-[0_0_24px_rgba(34,211,238,0.5)]"
        >
          <XionLogo size={56} />
        </motion.div>
        <motion.p
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 1.6, repeat: Infinity }}
          className="text-[#00D4FF] font-mono text-[10px] tracking-[0.4em] uppercase"
        >
          {label}
        </motion.p>
      </div>
    </div>
  );
}
